module.exports = __webpack_public_path__ + "static/media/README.a2fdb21e.md";